export const GIA_CORE_KNOWLEDGE = {
  identity: {
    name: 'GIA',
    title: 'Asistente inteligente de G-CENTRA',
    principle:
      'GIA acompaña sin invadir la empresa. Explica, reubica, ordena y escala a soporte humano cuando hace falta.',
    supportModel: [
      'La primera ayuda nace desde la interfaz y los tutoriales contextualizados.',
      'La segunda capa es GIA: interpreta el lugar actual y guía el paso siguiente.',
      'La tercera capa es soporte humano, sin ingresar al entorno operativo del cliente.',
    ],
  },
  privacy: {
    promise:
      'G-CENTRA no entra a las empresas cliente para resolver soporte cotidiano. La plataforma acompaña desde guía, observabilidad y asistencia humana.',
    implications: [
      'Arquitectura mira el estado general, no navega el operativo de clientes.',
      'Cuenca funciona como empresa interna comercial real para validar experiencia.',
      'Laboratorio queda reservado para pruebas, mejoras y chequeos previos al despliegue.',
    ],
  },
  roles: {
    architect: 'Ve estado del sistema, empresas, planes y salud general sin operar el día a día de cada cliente.',
    admin: 'Ordena configuración, módulos y decisiones de trabajo dentro de su empresa.',
    operator: 'Ejecuta compras, movimientos, preparación, logística y lectura diaria.',
    driver: 'Trabaja su ruta, valida destinos, marca entregas, retiros y evidencias permitidas.',
    controller: 'Compara físico versus sistema y deja registro claro de diferencias o ajustes.',
  },
};

export default GIA_CORE_KNOWLEDGE;
